export enum PlatformId {
  WINDOWS = 'windows',
  MAC = 'mac',
  LINUX = 'linux'
}
